<template lang="pug">
b-card#changeScrCode(
  ref="changeScrCode"
).inner.icon-password
  .col-4
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.security_tag')")
        DebounceInput(
          size="sm"
          autofocus
          type="text"
          :dirty="$v.securityTag.$dirty"
          :error="$v.securityTag.$error"
          v-model.trim.lazy="$v.securityTag.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.securityTag" :name="$t('ui.security_tag')")
      b-form-group(:label="$t('ui.security_code')")
        DebounceInput(
          size="sm"
          type="password"
          :dirty="$v.securityCode.$dirty"
          :error="$v.securityCode.$error"
          v-model.trim.lazy="$v.securityCode.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.securityCode" :name="$t('ui.security_code')")
      b-form-group(:label="$t('ui.combine.confirm_security_code')")
        DebounceInput(
          size="sm"
          type="password"
          :dirty="$v.securityCodeConfirm.$dirty"
          :error="$v.securityCodeConfirm.$error"
          v-model.trim.lazy="$v.securityCodeConfirm.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.securityCodeConfirm" :name="$t('ui.combine.confirm_security_code')", :name2="$t('ui.security_code')")
    b-alert.m-0.text-center.animated.flash(:show="!feedback.success" variant="danger") {{ $t("error." + feedback.status) }}
    div(slot="footer")
      SubmitButton.btn-brand(:loading="loading" icon="fa fa-times" :text="$t('ui.clear')" type="button" @click="emptyScrCode" size="sm" variant="primary").mr-2
      SubmitButton.btn-brand(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" type="button" @click="changeScrCode" size="sm" variant="secondary")
      SubmitButton.btn-brand.float-right(v-if="!securityDisabled" :loading="loading" icon="fa fa-times" :text="$t('ui.disable')" type="button" @click="disableScrCode" size="sm" variant="danger" highlight=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import { required, requiredIf, minLength, maxLength, sameAs, helpers, alphaNum } from "vuelidate/lib/validators";
import DebounceInput from "@/library/DebounceInput";
const containAlphaNum = helpers.regex("containAlphaNum", /^(?=.*\d)(?=.*[a-zA-Z])/);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      securityTag: "",
      securityCode: "",
      securityCodeConfirm: "",
      securityCodeCollapse: false,
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    securityTag: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    securityCode: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    securityCodeConfirm: {
      required,
      sameAs: sameAs("securityCode")
    }
  },
  computed: {
    getSecurityTag() {
      return this.$store.getters.securityTag || null;
    },
    securityDisabled() {
      return this.$store.getters.securityDisabled;
    }
  },
  mounted: function() {
    this.securityTag = this.getSecurityTag;
  },
  methods: {
    changeSecurity: function(securityTag, securityDisabled) {
      var json = {
        security_tag: securityTag,
        security_disabled: securityDisabled,
      }
      this.$store.dispatch("user/setSecurity", json);
    },
    toggleSrcCodeCollapse: function() {
      this.securityCodeCollapse = !this.securityCodeCollapse;
    },
    changeScrCode: function() {
      this.$helpers
        .alert({
          title: this.$t("ui.combine.update_security"),
          text: this.$t("message.update_security_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmChangeScrCode();
          }
        });
    },
    confirmChangeScrCode: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.securityUpdateUrl();

        var json = {
          auth_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.loginId,
          login_id: this.$store.getters.loginId,
          security_disabled: false,
          security_tag: this.securityTag,
          security_code: this.securityCode,
          account_id: this.$store.getters.accountId
        };

      this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }

                this.feedback.status = response.data.statusdesc;

                if (this.feedback.success == true) {
                  this.changeSecurity(this.securityTag, false);
                  this.$helpers.showToast(this.$t("ui.combine.update_security"), this.$t("message.successful_update_security"), "success");
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    disableScrCode: function() {
      this.$helpers
        .alert({
          title: this.$t("ui.combine.disable_security"),
          text: this.$t("message.disable_security_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmDisableScrCode();
          }
        });
    },
    confirmDisableScrCode: function() {
      let url = config.securityUpdateUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        login_id: this.$store.getters.loginId,
        account_id: this.$store.getters.accountId,
        security_disabled: true
      };

    this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.changeSecurity(null, true);
                this.$helpers.showToast(this.$t("ui.combine.disable_security"), this.$t("message.successful_disable_security"), "success");
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    emptyScrCode: function() {
      this.securityCode = "";
      this.securityCodeConfirm = "";

      this.$nextTick(() => {
        this.$v.$reset();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
// .form-control:disabled, .form-control[readonly] {
//   background-color: rgba(255, 255, 255, 0.5) !important;
// }
</style>
